export class Claims {
    tokenAuthTime: number;
    oid: string;
    role: string;
    email: string;
    newUser: boolean;
    displayName: string;
    type: string;
    companyName: string;
    phoneNumber: string;
    countryCode: string;

    constructor(oid: string,
                role: string,
                email: string,
                name: string,
                newUser: boolean = false,
                type: string,
                companyName: string,
                phoneNumber: string,
                countryCode: string,
                tokenAuthTime: number) {
        this.oid = oid; // Object Id of the user
        this.role = role;
        this.email = email;
        this.newUser = newUser;
        this.displayName = name;
        this.type = type;
        this.companyName = companyName;
        this.phoneNumber = phoneNumber;
        this.countryCode = countryCode;
        this.tokenAuthTime = tokenAuthTime;
    }
}
